/**
 * Sort comparator
 * @param {any} a
 * @param {any} b
 * @returns {-1|0|1} -1: a is smaller, 1: b is smaller, 0: they are equal
 */
const compare = (a, b) => a === b ? 0 : a < b ? -1 : 1;
export default compare;
//# sourceMappingURL=compare.mjs.map